export const esWallet = {
  status: {
    offline: 'Fuera de línea',
    online: 'En línea',
    wrongNetwork: 'Red incorrecta',
  },
  connect: 'Conectar wallet',
  connectAction: 'Conectar wallet',
  disconnectAction: 'Desconectar wallet',
  switchNetworkAction: 'Cambiar red',
  openAccount: 'Abrir cuenta',
  openConnect: 'Conectar wallet',
  connectToSeeBalances: 'Conecta tu wallet para ver balances on-chain.',
  keysStayInWallet: 'Tus claves permanecen en tu wallet.',
  session: 'Sesión',
  error: {
    connectToContinue: 'Conecta tu wallet para continuar.',
    noValidOperation: 'No hay una operación válida para ejecutar.',
    networkUnavailable: 'La red no está disponible. Revisa tu conexión e inténtalo de nuevo.',
    connectorNotFound: 'No se encontró la wallet conectada. Vuelve a conectar MetaMask.',
    signingPrepareFailed: 'No se pudo preparar la firma en la wallet. Abre MetaMask e inténtalo de nuevo.',
    wrongNetworkMessage: (chainName: string, chainId: number, connectedChainId: number) =>
      `Por favor, cambia la wallet a ${chainName} (chain ID ${chainId}). Conectada: ${connectedChainId}.`,
    userRejected: 'Cancelaste la firma en MetaMask.',
    chainMismatch: 'MetaMask está en otra red. Cambia a la red de la app e inténtalo de nuevo.',
    metamaskNoResponse:
      'MetaMask no respondió. Abre MetaMask, vuelve a la app y pulsa Convertir otra vez.',
    chainPrepareFailed: 'No se pudo preparar la red para firmar. Recarga la app e inténtalo de nuevo.',
    txSendFailed: 'No se pudo enviar la transacción a MetaMask. Abre la app e inténtalo de nuevo.',
    walletNotFound: 'No se encontró la wallet conectada.',
    addChainRejected: (chainName: string) =>
      `Debes aceptar añadir la red ${chainName} en MetaMask para continuar.`,
    configureChainFailed:
      'No se pudo configurar la red en MetaMask. Abre MetaMask, acepta añadir la red e inténtalo de nuevo.',
  },
} as const

export const esPortfolio = {
  connectTitle: 'Conecta tu wallet',
  connectDescription:
    'Vincula tu billetera para ver balances, activos y el resumen de tu portfolio on-chain.',
  tab: { summary: 'Resumen', movements: 'Movimientos' },
  nativeBalance: 'Saldo nativo',
  totalBalance: 'Saldo total',
  walletBalance: 'Saldo en billetera',
  assetsInWallet: 'Activos en billetera',
  connectToListTokens: 'Conecta tu wallet para listar tus tokens.',
  noVisibleBalances: 'No hay balances visibles en los tokens rastreados.',
  lpPositions: 'Posiciones LP',
  manageLiquidity: 'Gestiona tu liquidez',
  bridgeTitle: 'Puente',
  bridgeSubtitle: 'Mueve activos entre cadenas',
  openPortfolio: 'Abrir portfolio',
  sectionTitle: 'Tu portfolio',
  sectionSubtitle: 'Balances y actividad en tu wallet',
  connectForAggregated: 'Conecta tu wallet para ver valor agregado',
  movements: {
    empty:
      'Aún no hay movimientos registrados desde esta app. Los swaps hechos aquí aparecerán en cuanto se envíen a la red.',
    noFilterResults: 'Sin movimientos para este filtro.',
  },
} as const

export const esExplore = {
  tab: { tokens: 'Tokens', markets: 'Mercados', pools: 'Pools' },
  search: {
    clear: 'Limpiar búsqueda',
    tokens: {
      title: 'No se encontraron activos',
      description: 'Prueba con otro símbolo, nombre o dirección de contrato.',
    },
    markets: {
      title: 'No se encontraron pares',
      description: 'Prueba con otro par o símbolo de token.',
    },
  },
  tokenScope: { catalog: 'Catálogo', imported: 'Importados', all: 'Todos' },
  token: {
    catalogTitle: 'Catálogo del ecosistema',
    importedTitle: 'Tokens importados',
    importedEmpty: 'No tienes tokens importados. Busca por contrato para añadir uno.',
    catalogEmpty: 'No hay tokens en el catálogo.',
  },
  markets: {
    searchPlaceholder: 'Busca pares o activos',
    dynamicsTitle: 'Dinámicas del mercado',
    filter: { up: 'En alza', down: 'A la baja' },
    pairsTitle: 'Pares',
    noFilterResults: 'Sin pares para este filtro.',
  },
  pools: {
    myLpPositions: 'Mis posiciones LP',
    activePools: 'Pools activas',
    aggregatedTvl: 'TVL agregado',
    sortByTvl: 'Por TVL',
    sortByVolume: 'Por volumen',
    sortByApy: 'Por APY',
    ecosystemTitle: 'Pools del ecosistema',
  },
} as const

export const esHomeDashboard = {
  prelaunch: {
    kicker: 'Aviso temporal',
    headline: 'Lanzamiento oficial en preparación',
    lead: 'Nuestro DEX se está preparando para el lanzamiento oficial. Sigue nuestros canales para novedades y anuncios.',
  },
  liveMarket: 'Mercado en vivo',
  liveMarketSubtitle: 'Tendencias de precio del par principal',
  noPrimaryPairPrice: 'Sin datos de precio para el par principal.',
  activePairs: 'Pares activos',
  activePairsSubtitle: 'Movers y pares con volumen',
  topMover: 'Top mover',
  exploreAllPairs: 'Todos los pares',
  exploreVolume: '+ volumen',
  viewAllMarkets: 'Ver todos los mercados →',
  quickAccess: 'Accesos rápidos',
  quickAccessSubtitle: 'Rutas frecuentes',
  quickAction: {
    swap: 'Swap',
    swapSub: 'Intercambio on-chain',
    exploreTokens: 'Explorar tokens',
    exploreTokensSub: 'Catálogo del ecosistema',
    explorePools: 'Explorar pools',
    explorePoolsSub: 'Liquidez y APY',
    markets: 'Mercados',
    marketsSub: 'Pares en movimiento',
    bridge: 'Puente',
    bridgeSub: 'Transferencias entre cadenas',
  },
  mobile: {
    trendingPairs: 'Pares en tendencia',
    quickAction: { explore: 'Explorar', portfolio: 'Portfolio', markets: 'Mercados', bridge: 'Puente' },
  },
} as const

export const esShell = {
  quickActions: 'Acciones rápidas',
  quickAction: { swap: 'Swap', explore: 'Explorar', positions: 'Posiciones', bridge: 'Puente' },
  commandPalette: {
    trigger: 'Search or jump to...',
    title: 'Command Palette',
    placeholder: 'Type a command or search markets...',
    quickActions: 'Quick Actions',
    openSwap: 'Abrir Swap',
    openBridge: 'Abrir puente',
    addLiquidity: 'Añadir liquidez',
    viewPortfolio: 'Ver portfolio',
    markets: 'Mercados',
    noIndexedPairs: 'Sin pares indexados.',
  },
  tokenSearch: {
    title: 'Buscar token',
    label: 'Buscar token',
    subtitle: 'Símbolo, nombre o contrato',
    aria: 'Buscar token por símbolo, nombre o contrato',
  },
  tokenPicker: {
    withBalance: 'Con saldo',
    withoutBalance: 'Sin saldo',
    noVisibleBalance: 'Sin saldo visible',
    featured: 'Destacados',
    all: 'Todas',
    tokens: 'Tokens',
  },
} as const
